import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "text-caption text-grey py-6 text-center"
}
const _hoisted_3 = { class: "tp-builder-row__toolbar" }
const _hoisted_4 = { class: "text-caption text-grey-darken-1" }
const _hoisted_5 = { class: "tp-builder-row__cells" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "tp-builder-cell__name" }
const _hoisted_8 = { class: "tp-builder-cell__meta" }
const _hoisted_9 = {
  key: 0,
  title: 'クリックして項目を配置'
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "text-error"
}
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  key: 4,
  class: "tp-builder-cell__phrase"
}
const _hoisted_14 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_15 = {
  key: 0,
  class: "text-caption text-grey-darken-1 mb-2"
}
const _hoisted_16 = {
  key: 3,
  class: "mb-2"
}
const _hoisted_17 = { class: "d-inline-flex align-center ga-1" }
const _hoisted_18 = { class: "d-inline-flex align-center ga-1" }
const _hoisted_19 = {
  key: 4,
  class: "mt-2"
}
const _hoisted_20 = { class: "d-flex flex-wrap ga-1" }
const _hoisted_21 = { class: "tp-preview" }
const _hoisted_22 = { class: "d-flex flex-wrap ga-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_info_tip = _resolveComponent("info-tip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "8"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-subtitle-2" }, "レイアウト", -1)),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                size: "small",
                variant: "outlined",
                color: "primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addRowDialog = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-table-row-plus-after", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[15] || (_cache[15] = _createTextVNode(" 行を追加 ", -1))
                ]),
                _: 1
              })
            ]),
            (_ctx.draft.rows.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " 行がありません。「行を追加」から作成してください。 "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.rows, (row, rowIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                key: rowIndex,
                class: "tp-builder-row mb-2"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(rowIndex + 1) + "行目", 1),
                  _createVNode(_component_v_btn, {
                    size: "x-small",
                    variant: "text",
                    color: "primary",
                    disabled: row.cells.length >= _ctx.maxCellsPerRow,
                    onClick: ($event: any) => (_ctx.addCell(rowIndex))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        size: "14"
                      }, {
                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                          _createTextVNode("mdi-table-column-plus-after", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[18] || (_cache[18] = _createTextVNode(" 列を追加 ", -1))
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    size: "x-small",
                    variant: "text",
                    icon: "mdi-arrow-up",
                    title: "1つ上へ",
                    disabled: rowIndex === 0,
                    onClick: ($event: any) => (_ctx.moveRow(rowIndex, -1))
                  }, null, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_btn, {
                    size: "x-small",
                    variant: "text",
                    icon: "mdi-arrow-down",
                    title: "1つ下へ",
                    disabled: rowIndex === _ctx.draft.rows.length - 1,
                    onClick: ($event: any) => (_ctx.moveRow(rowIndex, 1))
                  }, null, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_divider, {
                    vertical: "",
                    class: "mx-2 my-1"
                  }),
                  _createVNode(_component_v_btn, {
                    size: "x-small",
                    variant: "text",
                    color: "error",
                    onClick: ($event: any) => (_ctx.removeRow(rowIndex))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        start: "",
                        size: "14"
                      }, {
                        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                          _createTextVNode("mdi-delete-outline", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[20] || (_cache[20] = _createTextVNode(" 行を削除 ", -1))
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, (cell, cellIndex) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: cellIndex,
                      type: "button",
                      class: _normalizeClass(["tp-builder-cell", {
                'tp-builder-cell--selected':
                  _ctx.selected !== null &&
                  _ctx.selected.rowIndex === rowIndex &&
                  _ctx.selected.cellIndex === cellIndex,
                'tp-builder-cell--label': cell.type === 'label',
                'tp-builder-cell--empty': _ctx.isEmptyCell(cell),
                'tp-builder-cell--invalid': _ctx.cellErrors(cell, rowIndex, cellIndex).length > 0,
              }]),
                      style: _normalizeStyle({ width: `${_ctx.widthPercents(row.widths)[cellIndex]}%` }),
                      onClick: ($event: any) => (_ctx.select(rowIndex, cellIndex))
                    }, [
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isEmptyCell(cell) ? "空き" : cell.name || "（名称未設定）"), 1),
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.isEmptyCell(cell))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "＋項目"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.cellTypeLabels[cell.type]), 1)),
                        (cell.required)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "必須"))
                          : _createCommentVNode("", true),
                        (!cell.visible)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Excel非出力"))
                          : _createCommentVNode("", true),
                        (cell.phraseKey)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 文例: " + _toDisplayString(cell.phraseKey), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 14, _hoisted_6))
                  }), 128))
                ])
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4",
          class: "tp-builder-panel-col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              variant: "outlined",
              class: "pa-3"
            }, {
              default: _withCtx(() => [
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "セル設定", -1)),
                (!_ctx.selectedCell)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, " 編集するセルを選択してください。 "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.isEmptyCell(_ctx.selectedCell))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, " この列に何を置くか選んでください。「見出し」以外を選ぶと入力欄になります。 "))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedCell.type,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCell.type) = $event)),
                          _ctx.onTypeChange
                        ],
                        items: _ctx.cellTypeItems,
                        label: "セル型",
                        variant: "outlined",
                        density: "compact",
                        color: "primary",
                        class: "mb-2",
                        "hide-details": ""
                      }, {
                        "append-inner": _withCtx(() => [
                          _createVNode(_component_info_tip, null, {
                            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                              _createTextVNode(" 「見出し」は入力できない項目名だけのセルです。", -1),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 「参照」は上位の帳票の値をそのまま映すセルで、どのセルから引くかは 転記ルールで決めます。", -1),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" それ以外は入力欄になります。 ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items", "onUpdate:modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.selectedCell.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCell.name) = $event)),
                        label: "項目名",
                        variant: "outlined",
                        density: "compact",
                        color: "primary",
                        class: "mb-2",
                        "hide-details": ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.selectedCell.itemKey,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCell.itemKey) = $event)),
                        label: "項目キー (半角英数字)",
                        variant: "outlined",
                        density: "compact",
                        color: "primary",
                        class: "mb-2",
                        hint: 
                _ctx.selectedCell.type === 'label'
                  ? '見出しセルは省略できます'
                  : '帳票の値・転記ルールの識別子です'
              ,
                        "persistent-hint": ""
                      }, {
                        "append-inner": _withCtx(() => [
                          _createVNode(_component_info_tip, null, {
                            default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                              _createTextVNode(" 書かれた内容・コメント・転記ルールを、このセルに結びつけるための識別子です。", -1),
                              _createElementVNode("br", null, null, -1),
                              _createElementVNode("strong", null, "公開したあとに変えると、別のセルとして扱われます", -1),
                              _createTextVNode("。このセルを 指していた転記ルールは外れ、「過去の記載から引用」でも以前の記入は出てきません （作成済みの帳票は作成時のレイアウトのままなので、書いた内容が消えることは ありません）。", -1),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 半角英数字と - _ が使えます。1つのレイアウトの中で重複はできません。 ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue", "hint"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.selectedWidth,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedWidth) = $event)),
                        modelModifiers: { number: true },
                        label: "列幅 (比率)",
                        type: "number",
                        min: "1",
                        variant: "outlined",
                        density: "compact",
                        color: "primary",
                        class: "mb-2",
                        "hide-details": ""
                      }, {
                        "append-inner": _withCtx(() => [
                          _createVNode(_component_info_tip, null, {
                            default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                              _createTextVNode(" 同じ行にある他の列との", -1),
                              _createElementVNode("strong", null, "比率", -1),
                              _createTextVNode("です。1 と 2 なら後者が2倍の幅になります。", -1),
                              _createElementVNode("br", null, null, -1),
                              _createTextVNode(" 画面の見た目とExcelの列幅の両方に効きます。 ", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.selectedCell.type === 'select')
                        ? (_openBlock(), _createBlock(_component_v_textarea, {
                            key: 1,
                            modelValue: _ctx.optionsText,
                            "onUpdate:modelValue": [
                              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.optionsText) = $event)),
                              _ctx.onOptionsChange
                            ],
                            label: "選択肢 (1行に1つ)",
                            rows: "4",
                            variant: "outlined",
                            density: "compact",
                            color: "primary",
                            class: "mb-2",
                            "hide-details": ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.isInputCell(_ctx.selectedCell))
                        ? (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 2,
                            modelValue: _ctx.phraseKeyText,
                            "onUpdate:modelValue": [
                              _cache[6] || (_cache[6] = ($event: any) => ((_ctx.phraseKeyText) = $event)),
                              _ctx.onPhraseKeyChange
                            ],
                            label: "文例グループ",
                            variant: "outlined",
                            density: "compact",
                            color: "primary",
                            class: "mb-2",
                            hint: "同じ値を入れたセル同士で文例を共有します（例: 主な活動）",
                            "persistent-hint": ""
                          }, {
                            "append-inner": _withCtx(() => [
                              _createVNode(_component_info_tip, null, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createTextVNode(" 文例（よく使う定型文）をまとめる単位です。", -1),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 同じ値を入れたセルは同じ文例を共有します。週案の月〜火〜金の「主な活動」を 1つにまとめる、といった使い方をします。", -1),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" 空にすると、そのセルでは文例を呼び出せません。 ", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue", "onUpdate:modelValue"]))
                        : _createCommentVNode("", true),
                      (_ctx.isInputCell(_ctx.selectedCell) && _ctx.selectedCell.phraseKey)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createVNode(_component_v_btn, {
                              size: "x-small",
                              variant: "text",
                              color: "primary",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('open-phrase', _ctx.selectedCell.phraseKey)))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  start: "",
                                  size: "14"
                                }, {
                                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                    _createTextVNode("mdi-text-box-multiple-outline", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" 「" + _toDisplayString(_ctx.selectedCell.phraseKey) + "」の文例を編集 ", 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.selectedCell.required,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedCell.required) = $event)),
                        density: "compact",
                        "hide-details": "",
                        color: "primary",
                        disabled: !_ctx.isInputCell(_ctx.selectedCell)
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_17, [
                            _cache[27] || (_cache[27] = _createTextVNode(" 必須 ", -1)),
                            _createVNode(_component_info_tip, null, {
                              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                _createTextVNode(" 空のままでは提出できなくなります。", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 「Excelに出力する」を外したセルは、必須にしても提出時に検査されません。 ", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      _createVNode(_component_v_checkbox, {
                        modelValue: _ctx.selectedCell.visible,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedCell.visible) = $event)),
                        density: "compact",
                        "hide-details": "",
                        color: "primary"
                      }, {
                        label: _withCtx(() => [
                          _createElementVNode("span", _hoisted_18, [
                            _cache[29] || (_cache[29] = _createTextVNode(" Excelに出力する ", -1)),
                            _createVNode(_component_info_tip, null, {
                              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                _createTextVNode(" 外すと、Excelではこのセルは", -1),
                                _createElementVNode("strong", null, "枠だけ残って中身が出ません", -1),
                                _createTextVNode(" （列そのものは詰まりません）。", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 画面では今までどおり入力でき、「Excel非出力」と表示されます。", -1),
                                _createElementVNode("br", null, null, -1),
                                _createTextVNode(" 園内のメモなど、印刷して配る帳票に載せたくない項目に使います。 ", -1)
                              ]))]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      (_ctx.selectedCellErrors.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCellErrors, (error) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: error,
                                class: "text-caption text-error"
                              }, _toDisplayString(error), 1))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_divider, { class: "my-3" }),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "text",
                          disabled: _ctx.isEmptyCell(_ctx.selectedCell),
                          onClick: _ctx.clearSelectedCell
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { start: "" }, {
                              default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                _createTextVNode("mdi-eraser", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[31] || (_cache[31] = _createTextVNode(" このセルを空にする ", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"]),
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "text",
                          color: "error",
                          disabled: _ctx.selectedRowCellCount <= 1,
                          onClick: _ctx.removeSelectedCell
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { start: "" }, {
                              default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                _createTextVNode("mdi-delete-outline", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[33] || (_cache[33] = _createTextVNode(" このセルを削除 ", -1))
                          ]),
                          _: 1
                        }, 8, ["disabled", "onClick"])
                      ]),
                      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "text-caption text-grey-darken-1 mt-1" }, " 「空にする」は列を残したまま項目だけを外します。「削除」は列そのものを詰めます。 ", -1))
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.addRowDialog,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addRowDialog) = $event)),
      "max-width": "560px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                _createTextVNode("行を追加", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "列構成", -1)),
                _createVNode(_component_v_btn_toggle, {
                  modelValue: _ctx.newRowColumns,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newRowColumns) = $event)),
                  density: "compact",
                  variant: "outlined",
                  divided: "",
                  mandatory: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rowPresetItems, (preset) => {
                      return (_openBlock(), _createBlock(_component_v_btn, {
                        key: preset.value,
                        value: preset.value,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(preset.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_checkbox, {
                  modelValue: _ctx.newRowHasHeader,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newRowHasHeader) = $event)),
                  label: "先頭を見出し列にする",
                  density: "compact",
                  color: "primary",
                  "hide-details": "",
                  class: "mt-1"
                }, null, 8, ["modelValue"]),
                _cache[38] || (_cache[38] = _createElementVNode("div", { class: "text-subtitle-2 mt-3 mb-1" }, "プレビュー", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newRowPreview, (preview, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["tp-preview__cell", { 'tp-preview__cell--label': preview.isHeader }]),
                      style: _normalizeStyle({ width: `${preview.widthPercent}%` })
                    }, _toDisplayString(preview.label), 7))
                  }), 128))
                ]),
                _createVNode(_component_v_divider, { class: "my-4" }),
                _cache[39] || (_cache[39] = _createElementVNode("div", { class: "text-subtitle-2 mb-1" }, "よく使う構成から作る", -1)),
                _cache[40] || (_cache[40] = _createElementVNode("div", { class: "text-caption text-grey-darken-1 mb-2" }, " 見出し行と、同じ列構成の空き行を1行ずつ追加します。空きセルをクリックすると項目を配置できます。 ", -1)),
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seedItems, (seed) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: seed.value,
                      size: "small",
                      variant: "outlined",
                      color: "primary",
                      onClick: ($event: any) => (_ctx.addSeedRows(seed.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(seed.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _cache[41] || (_cache[41] = _createElementVNode("div", { class: "text-caption text-grey-darken-1 mt-4" }, " 追加した行は末尾に入ります。並べ替えは行ごとの矢印で行えます。 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addRowDialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("キャンセル", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  variant: "flat",
                  onClick: _ctx.addRow
                }, {
                  default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                    _createTextVNode("追加", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}